import script from "./HeaderMain.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderMain.vue?vue&type=script&setup=true&lang=js"

import "./HeaderMain.vue?vue&type=style&index=0&id=4dd710f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd710f4"]])

export default __exports__